export default __webpack_public_path__ + "static/media/style-angelusAntiqueStone.24f623fb.jpg";